module.exports = __webpack_public_path__ + "img/user_icon.943ffe67.png";